var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 6.5,
    fill: "white",
    stroke: "#2676C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7777 30.778L33.7777 23.778C34.2077 23.348 34.2077 22.6526 33.7777 22.2225L26.7777 15.2225C26.3476 14.7925 25.6524 14.7925 25.2223 15.2225C24.7923 15.6526 24.7923 16.348 25.2223 16.778L30.3446 21.9003H15C14.3918 21.9003 13.9 22.3921 13.9 23.0003C13.9 23.6085 14.3918 24.1003 15 24.1003H30.3446L25.2223 29.2225C24.7923 29.6526 24.7923 30.348 25.2223 30.778C25.4368 30.9925 25.7185 31.1003 26 31.1003C26.2815 31.1003 26.5632 30.9925 26.7777 30.778Z",
    fill: "#0B4B84",
    stroke: "#0B4B84",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/next-btn.e3e2b265a30cbae16fc8ab40aa700d65.svg";
export { ForwardRef as ReactComponent };